// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1U8Zv","item":"PaymentsMobile_item__2LfaL","label":"PaymentsMobile_label__2KQo2","amount":"PaymentsMobile_amount__1EzwC"};